
import { mapState, mapMutations } from 'vuex';

export default {
  name: 'Favorite',
  props: {
    sku: {
      type: String,
      required: true,
    },
    onlyIcon: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      isFavorite: false,
      isLoading: false,
      myFavoritesIds: [],
    };
  },

  computed: {
    ...mapState(['user', 'patientId', 'myFavorites']),
  },

  mounted() {
    if (this.user && this.myFavorites && this.myFavorites.length) {
      const myFavoritesIds = this.myFavorites.map((f) => f.sage_id);
      this.isFavorite = myFavoritesIds.includes(this.sku);
    }
  },

  methods: {
    ...mapMutations(['openLoginModal', 'updateFavorites']),

    async submit() {
      this.isLoading = true;
      if (!this.isFavorite) {
        try {
          await this.$bolev.addToFavorites({
            sku: this.sku,
            patient_id: this.patientId,
          });
          this.isFavorite = true;
          this.isLoading = false;
          this.updateFavorites(this.sku);
        } catch (_) {
          this.isLoading = false;
        }
      } else {
        try {
          await this.$bolev.removeFromFavorites({
            sku: this.sku,
            patient_id: this.patientId,
          });
          this.isFavorite = false;
          this.isLoading = false;
          this.updateFavorites(this.sku);
        } catch (_) {
          this.isLoading = false;
        }
      }
    },
  },
};
